import { NAVIOBUILD_OFFLINE_CAPABILITIES } from './naviobuild-offline-capabilities.js';

import type { NavioBuildOfflineCapability } from './naviobuild-offline-contract.js';

export function getNavioBuildOfflineCapability(
  routeId: string
): NavioBuildOfflineCapability | undefined {
  return NAVIOBUILD_OFFLINE_CAPABILITIES.find((capability) => capability.routeId === routeId);
}

export function isNavioBuildRouteOfflineReady(routeId: string): boolean {
  const capability = getNavioBuildOfflineCapability(routeId);
  return Boolean(
    capability &&
    capability.requiredForLaunch &&
    capability.readScope !== 'none' &&
    capability.conflictPolicy !== 'blocked_offline'
  );
}
